import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { isActiveJob, onActiveJobsChange, readActiveJobs, scenarioPath, untrackJob } from "@/lib/mcJobs";

const POLL_MS = 3000;

// Globale melder: zolang er Monte Carlo-taken van deze gebruiker lopen, wordt
// elke 3 s de status opgevraagd; is een taak klaar → toast met "Bekijken".
export default function McJobNotifier() {
  const [jobs, setJobs] = useState(readActiveJobs);
  const nav = useNavigate();
  const loc = useLocation();
  const locRef = useRef(loc.pathname);
  locRef.current = loc.pathname;

  useEffect(() => onActiveJobsChange(() => setJobs(readActiveJobs())), []);

  useEffect(() => {
    if (jobs.length === 0) return undefined;
    let alive = true;
    const tick = async () => {
      for (const j of jobs) {
        try {
          const { data } = await api.get(`/monte-carlo/jobs/${j.id}`);
          if (!alive || isActiveJob(data)) continue;
          untrackJob(j.id);
          const onPage = locRef.current === scenarioPath(j);
          const name = j.scenarioName || data.scenario_name || "scenario";
          if (data.status === "done") {
            toast.success(`Monte Carlo klaar — ${Number(data.n_runs || 0).toLocaleString("nl-NL")} simulaties voor "${name}".`, {
              duration: 10000,
              action: onPage ? undefined : { label: "Bekijken", onClick: () => nav(scenarioPath(j)) },
            });
          } else if (data.status === "failed") {
            toast.error(`Monte Carlo mislukt voor "${name}": ${data.error || "onbekende fout"}`, { duration: 10000 });
          }
        } catch (e) {
          if (e.response?.status === 404) untrackJob(j.id);
        }
      }
    };
    tick();
    const t = setInterval(tick, POLL_MS);
    return () => { alive = false; clearInterval(t); };
  }, [jobs, nav]);

  return null;
}
